import { createContext, useContext } from 'react';
import { DEFAULT_LOCALE, type Locale } from '@debtbot/shared';
import { ru, type Dictionary } from './ru';
import { uz } from './uz';

export type { Dictionary } from './ru';

const DICTS: Record<Locale, Dictionary> = { ru, uz };

export function dictionary(locale: Locale): Dictionary {
  return DICTS[locale];
}

/**
 * Текущий язык как модульное состояние — для функций вне React (lib/format.ts).
 * LocaleProvider синхронизирует его при каждом рендере, так что к моменту вызова
 * форматтеров в дереве значение актуально.
 */
let current: Locale = DEFAULT_LOCALE;
export function getLocale(): Locale {
  return current;
}
export function setLocale(locale: Locale): void {
  current = locale;
}
export function t(): Dictionary {
  return DICTS[current];
}

export const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export function useT(): Dictionary {
  return DICTS[useContext(LocaleContext)];
}
